module.exports = __webpack_public_path__ + "static/media/rb6.a65e7ba0.jpg";